<template>
    <drawer title="Media Upload">
        <div class="page-data__container">
            <template>
                <media-upload ref="upload" @cancel="onCancel" />
            </template>
        </div>
    </drawer>
</template>

<script>
import { mapState } from 'vuex';
import Drawer from '@/components/shared/drawer/drawer';
import MediaUpload from '@/components/page-editor/navigation-tree/media-upload';
import { drawerHelperMixin, TYPE_IMAGE } from '@/mixins/drawer-helper';

export default {
    components: {
        Drawer,
        MediaUpload,
    },

    mixins: [drawerHelperMixin],

    computed: {
        ...mapState({
            mediaItem: ({ page }) => page.newPagePath,
        }),
    },

    methods: {
        onCancel() {
            this.$refs.upload.reset();
            this.openMediaDrawer(TYPE_IMAGE, this.mediaItem);
        },
    },
};
</script>
